/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class EventRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    return hash({
      event: this.store.findRecord('events/event', params.event_id),
      communityNotices: this.store.query('posts/communitynotice', {
        eventId: params.event_id,
        include: 'reactions,comments,commentAuthors',
      }),
      staffNotices: this.store.query('posts/staffnotice', {
        eventId: params.event_id,
        include: 'reactions,comments,commentAuthors',
      }),
      people: this.store.findAll('person'),
      permissions: this.store.findAll('events/permission'),
      mitigations: this.store.findAll('events/mitigation'),
      peopleSchemaFields: this.store.findAll('people-schema/field'),
      update: () => this.refresh(),
    });
  }
}
